export const classes = {
  paper: 'fixed top-8 rounded-2xl w-[98vw] max-w-[960px] min-w-[300px] p-0',
};
